module.exports = "mutation DeleteVoucher($voucherId:ID!){deleteVoucher(voucherId:$voucherId){success}}"